import dayjs from 'dayjs';

import { handleMonthlyRecurrence } from 'src/Hooks/Forms/UseCreateEventForm/handleMonthlyRecurrence';
import { handleYearlyRecurrence } from 'src/Hooks/Forms/UseCreateEventForm/handleYearlyRecurrence';
import { RecurrenceValues } from 'src/Hooks/Forms/UseCreateEventForm/useCreateEventForm.types';
import {
  CreateEventDto,
  RecurrenceDto,
  RecurrenceDtoFrequencyEnum,
} from 'src/Services/API/generated';
import parseIntSafe from 'src/Services/Shared/parseIntSafe';

import { handleWeeklyRecurrence } from './handleWeeklyRecurrence';

export const transformFormValuesToRecurrenceDto = (
  values: RecurrenceValues
): RecurrenceDto | null => {
  if (!values.frequency) return null;

  const frequency =
    values.frequency === 'CUSTOM'
      ? (values.customFrequency as RecurrenceDtoFrequencyEnum)
      : values.frequency;

  const recurrence: CreateEventDto['recurrence'] = {
    frequency,
    timezone: values.timezone,
    dtstart: values.dtstart,
  };

  if (values.frequency === 'CUSTOM') {
    recurrence.interval = parseIntSafe(values.interval);

    const handlers = {
      YEARLY: handleYearlyRecurrence,
      MONTHLY: handleMonthlyRecurrence,
      WEEKLY: handleWeeklyRecurrence,
    };

    const handler = handlers[values.customFrequency as keyof typeof handlers];
    if (handler) {
      Object.assign(recurrence, handler(values));
    }
  }

  recurrence.until = values.until ? dayjs(values.until) : undefined;

  return recurrence;
};
